import apiErrors from './errors'
import misc from './misc'
import asset from './asset'
import jira from './jira'
import bookmark from './bookmark'
import audit from './audit'
import bp from './bp'
import customField from './custom-field'
import history from './history'
import review from './review'
import securityNeed from './security-need'
import status from './status'
import dateRange from './date-range'
import massEdit from './mass-edit'
import date from './date'
import module from './module'
import method from './method'
import roles from './roles'
import responsibleCost from './responsible-cost'
import dashboard from './dashboard'
import rule from './rule'
import user from './user'
import reference from './reference'
import risk from './risk'
import settings from './settings'
import threat from './threat'
import vulnerability from './vulnerability'
import document from './document'
import journal from './journal'
import pdf from './pdf'
import importLocale from './import'

export default {
	apiErrors,
	misc,
	jira,
	bookmark,
	asset,
	audit,
	bp,
	customField,
	history,
	review,
	securityNeed,
	status,
	dateRange,
	massEdit,
	date,
	module,
	method,
	roles,
	responsibleCost,
	dashboard,
	rule,
	user,
	reference,
	risk,
	settings,
	threat,
	vulnerability,
	document,
	journal,
	pdf,
	import: importLocale,

	// need to sort all these as well:
	language: 'Language',
	estonian: 'Estonian',
	english: 'English',
	assets: 'Assets',
	dataAssets: 'Data assets',
	role: 'Role | Roles',
	permissions: 'Permissions',
	customFields: 'Custom Fields',
	logout: 'Logout',
	standardVersionUpdateAvailable: 'Standard version update available',
	notComplete: 'Not Complete',
	normal: 'Normal',
	big: 'Big',
	veryBig: 'Very Big',
	businessProcesses: 'Business processes',
	standardUpgrade: 'Standard Upgrade',
	measureImport: 'Measure Import',
	backup: 'Backup',
	overallStatus: 'Overall Status',
	measure: 'Measure | Measures',
	active: 'Active',
	notActive: 'Not active',
	price: 'Price',
	connectionColumns: 'Connections',
	connections: 'Connected objects',
	columns: 'Columns',
	send: 'Send',
	login: 'Login',
	idCard: 'ID card',
	activate: 'Activate',
	licenseCode: 'License code',
	licenseExpires: 'License expires',
	confidentiality: 'Confidentiality',
	availability: 'Availability',
	integrity: 'Integrity',
	dataAsset: 'Data asset',
	title: 'Title',
	responsible: 'Responsible',
	priority: 'Priority',
	subrule: 'Subrule',
	low: 'Low',
	medium: 'Medium',
	high: 'High',
	choose: 'Choose ...',
	editMeasure: 'Edit measure',
	main: 'Main',
	standard: 'Standard',
	relatedAssets: 'Related assets',
	vb: 'VB',
	b: 'B',
	n: 'N',
	code: 'Code',
	description: 'Description',
	chooseAsset: 'Choose asset',
	h: 'H',
	s: 'S',
	m: 'M',
	core: 'Core',
	measuresFound: 'Measures found',
	columnsOptions: 'Column options',
	measureConnectionsFound: 'Measure connections found',
	appliedUserRights: 'Applied user rights',
	userRights: 'User rights',
	editMethod: 'Edit method',
	chooseBusinessProcess: 'Choose business process',
	chooseModule: 'Choose module',
	owner: 'Owner',
	location: 'Location',
	firstname: 'First name',
	lastname: 'Last name',
	idCode: 'ID code',
	password: 'Password',
	email: 'E-mail',
	emailActivate: 'E-mail activation',
	phone: 'Phone',
	contact: 'Contact',
	mainInstitution: 'Main institution',
	adUser: 'AD username',
	contactResponsible: 'Contact/responsible',
	association: 'Association | Associations',
	allBusinessProcesses: 'All Business processes',
	assetAssociations: 'Asset associations',
	methods: 'Methods',
	institution: 'Institution | Institutions',
	securityMethodChangedSuccessfully: 'Security method changed successfully',
	hasPersonalData: 'Has Personal Data',
	methodWillNotApply: 'Measure will not apply',
	methodWillNotImplement: 'Measure will not implement',
	methodNotImplemented: 'Measure is not implemented',
	methodImplemented: 'Implement all rules',
	willNotApplyCommentRequired: 'Will not apply reason is required.',
	instance: 'Instance',
	version: 'Version',
	activationEmailSent: 'Activation e-mail has been sent',
	address: 'Address',
	progressTooltip: 'Measures: {count}\n Percentage: {percentage}%\n Status: {status}',
	standardVersion: 'Standard Version',
	userManual: 'User Manual',
	downloadUsermanual: 'Download User Manual',
	businessProcess: 'Business process',
	lastReview: 'Last review',
	confirmUserDelete: 'Please confirm user deletion',
	confirmRoleDelete: 'Please confirm role deletion',
	replacementResponsible: 'Replacement responsible',
	custom: 'Custom',
	respObjects: 'Responsible for objects',
	noResponsibilitiesToTransfer: 'does not have any responsibilities to transfer.',
	confirmRoleReplaceResponsible: 'role responsible replacement',
	confirmUserReplaceResponsible: 'user responsible replacement',
	risks: 'Risks',
}
